import React, { useCallback, useState } from 'react';

import { Dialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import UpdateUserForm from '../../components/users/UpdateUserForm';
import ValidationException from '../../exceptions/ValidationException';
import User from '../../models/User';
import UserService from '../../services/user.service';

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
      margin: '16px',
      maxWidth: '500px',
      overflow: 'visible',
      width: '100%',
    },
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: '36px 24px',
  },
}));

const UpdateUserModal = ({ open, onClose, onExited, onUserUpdated, user, updateType }) => {
  const classes = useStyles();
  const [validationErrors, setValidationErrors] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const userService = new UserService();

  const updateUser = async (userData) => {
    try {
      setIsSubmitting(true);

      const result = await userService.updateUser(user.id, userData);

      if (onUserUpdated) {
        await onUserUpdated();
      }

      enqueueSnackbar('User updated successfully', { variant: 'success' });
      onClose();
      return result;
    } catch (error) {
      console.error('Error updating user:', error);

      if (error instanceof ValidationException) {
        setValidationErrors(error.errors);
      } else {
        enqueueSnackbar('Failed to update user', { variant: 'error' });
      }
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = useCallback(() => {
    setValidationErrors(null);
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.dialog}
      TransitionProps={{
        onExited,
      }}>
      <div className={classes.modalContent}>
        <UpdateUserForm
          onSubmit={updateUser}
          defaultData={user ? new User(user) : new User()}
          updateType={updateType}
          validationErrors={validationErrors}
          isSubmitting={isSubmitting}
          onCancel={handleClose}
        />
      </div>
    </Dialog>
  );
};

export default UpdateUserModal;
